/**
 * IdeasEmptyState.js
 * Placeholder shown when no ideas have been generated yet.
 */
import React from 'react';
import { Box, Typography, Avatar, alpha } from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';

export default function IdeasEmptyState() {
    return (
        <Box sx={{
            textAlign: 'center', p: 4, flex: 1,
            display: 'flex', flexDirection: 'column',
            justifyContent: 'center', alignItems: 'center',
            borderRadius: 4,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.4), rgba(255,255,255,0.05))',
            border: '2px dashed rgba(99, 102, 241, 0.15)',
            transition: 'all 0.3s ease',
        }}>
            <Avatar
                sx={{
                    bgcolor: alpha('#6366f1', 0.1),
                    color: '#6366f1',
                    width: 100,
                    height: 100,
                    mx: 'auto',
                    mb: 3,
                    boxShadow: '0 8px 32px -8px rgba(99, 102, 241, 0.3)',
                    animation: 'pulse 3s infinite ease-in-out',
                    '@keyframes pulse': {
                        '0%': { transform: 'scale(1)', opacity: 0.8 },
                        '50%': { transform: 'scale(1.08)', opacity: 1 },
                        '100%': { transform: 'scale(1)', opacity: 0.8 },
                    }
                }}
            >
                <AutoAwesomeIcon sx={{ fontSize: 50 }} />
            </Avatar>
            <Typography variant="h5" sx={{ fontWeight: 900, color: 'text.primary', mb: 2, letterSpacing: '-0.02em' }}>
                AI-Powered Ideas Await
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 460, mx: 'auto', lineHeight: 1.8, fontWeight: 500 }}>
                Enter a topic and select your platforms on the left to generate
                a high-converting content strategy tailored for your audience.
            </Typography>
        </Box>
    );
}
